module.exports = __webpack_public_path__ + "static/5-fa0880473abe0429dcd161216ab52119.jpeg";